import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { FormulaItemStruct } from '@shared/services/structs/formula/formula-item.struct';
import { FormulaCicloEmpresaRascunho } from '@shared/services/structs/formula/formula-ciclo-empresa-rascunho.struct';

/** Nome do controle raiz que guarda os rascunhos de ciclo da entidade em edição (natureza, regra ou DIFAL). */
const CONTROLE_CICLOS_EMPRESA = '_ciclosEmpresa';

/** Recolhe o estado atual de todas as seções do formulário, inclusive edições ainda não salvas. */
export function coletarEstadosFormulas(controle: AbstractControl): FormulaItemStruct[] {
    const resultado: FormulaItemStruct[] = [];
    const visitar = (atual: AbstractControl): void => {
        if (atual instanceof FormGroup) {
            const estados = atual.get('_estadosFormulas')?.value as FormulaItemStruct[] | undefined;
            if (Array.isArray(estados)) resultado.push(...estados);
            Object.values(atual.controls).forEach(visitar);
        } else if (atual instanceof FormArray) {
            atual.controls.forEach(visitar);
        }
    };
    visitar(controle.root);
    return resultado;
}

/** Obtém os rascunhos de ciclo pendentes da entidade dona do formulário (controle raiz `_ciclosEmpresa`). */
export function coletarCiclosEmpresa(controle: AbstractControl): FormulaCicloEmpresaRascunho[] {
    return (controle.root.get(CONTROLE_CICLOS_EMPRESA)?.value as FormulaCicloEmpresaRascunho[] | null | undefined) ?? [];
}

/**
 * Acrescenta o rascunho de ciclo configurado no modal do salvar. Um rascunho com as mesmas donas e os
 * mesmos membros de um já registrado o substitui; ciclos diferentes se acumulam, um por ciclo.
 */
export function registrarCicloEmpresa(controle: AbstractControl, ciclo: FormulaCicloEmpresaRascunho | null | undefined): void {
    if (!ciclo) return;
    const campo = controle.root.get(CONTROLE_CICLOS_EMPRESA);
    if (!campo) return;
    const atuais = coletarCiclosEmpresa(controle);
    campo.setValue([...atuais.filter(item => !mesmoCiclo(item, ciclo)), ciclo]);
}

function mesmoCiclo(a: FormulaCicloEmpresaRascunho, b: FormulaCicloEmpresaRascunho): boolean {
    return chavesOrdenadas(chavesDonas(a)) === chavesOrdenadas(chavesDonas(b))
        && chavesOrdenadas(a.membros.map(item => item.chaveVariavel)) === chavesOrdenadas(b.membros.map(item => item.chaveVariavel));
}

function chavesDonas(ciclo: FormulaCicloEmpresaRascunho): string[] {
    return (ciclo.entidades ?? []).map(item => `${item.tipoEntidade}|${item.codigoEntidade ?? ''}`);
}

function chavesOrdenadas(chaves: string[]): string {
    return [...new Set(chaves)].sort().join(',');
}
